import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const WinWin = () => {
  const theme = useTheme();

  const items = [
    {
      title: 'Para Danimar',
      text: 'Estatus de marca premium y eficaz: se diferencia de la competencia que usa publicidad tradicional y colorida. Danimar se asocia a quienes no juegan con la limpieza.',
    },
    {
      title: 'Para TNO',
      text: 'Refuerza la identidad de TNO Network como plataforma híbrida televisión–podcast: un entorno donde la publicidad compite en calidad con el contenido editorial.',
    },
    {
      title: 'Mística',
      text: 'El cliente percibe un producto validado por las voces que cuentan la verdad todos los días: confianza transferida al punto de venta.',
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Alianza
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Por qué es ganar-ganar
        </Box>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <Typography variant="h6" gutterBottom fontWeight={700} color="primary">
                {item.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default WinWin;
